import { interopDefault } from '~/utils';
import RouteEnum from '~/enums/RouteEnum';
import alerts from '~/routes/employee/alerts';
import applicants from '~/routes/employee/applicants';
import profiles from '~/routes/employee/profiles';
import registrationCodes from '~/routes/employee/registration-codes';
import emailTemplates from '~/routes/employee/email-templates';
import organization from '~/routes/employee/organization';
import search from '~/routes/employee/search';
import pings from '~/routes/employee/pings';
import account from '~/routes/employee/account';

export default () => [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/dashboard',
    name: RouteEnum.DASHBOARD,
    component: () =>
      interopDefault(
        import(/* webpackChunkName: 'employee:dashboard' */ '~/pages/employee/dashboard/show.vue')
      ),
  },
  ...organization,
  ...search,
  ...alerts,
  ...profiles,
  ...registrationCodes,
  ...emailTemplates,
  ...applicants,
  ...pings,
  ...account,
  {
    path: '/onboarding',
    name: RouteEnum.EMPLOYEE_ONBOARDING,
    component: () =>
      interopDefault(
        import(
          /* webpackChunkName: 'employee:onboarding' */ '~/pages/employee/flows/onboarding/onboarding.vue'
        )
      ),
  },
  {
    path: '/help',
    name: RouteEnum.HELP,
    component: () =>
      interopDefault(import(/* webpackChunkName: 'employee:help' */ '~/pages/employee/help.vue')),
  },
];
